/**
 * Keeps asynchronous customer-order item loads deterministic in the supplier
 * order wizard. The selected order is passed by the Select callback, while
 * Ant Form applies that field value asynchronously; therefore the form value
 * must not be used as a completion guard.
 */
export type LatestCustomerOrderRequestGate = {
  begin: () => number;
  invalidate: () => void;
  isCurrent: (token: number) => boolean;
};

export const createLatestCustomerOrderRequestGate = (): LatestCustomerOrderRequestGate => {
  let latestToken = 0;

  return {
    begin: () => {
      latestToken += 1;
      return latestToken;
    },
    invalidate: () => {
      latestToken += 1;
    },
    isCurrent: (token: number) => token === latestToken,
  };
};
